import Vue from 'vue';
// eslint-disable-next-line no-unused-vars
import * as Sentry from '@sentry/browser';
// import router from '@/router/router';
// import { store } from '@/store';
import Home from '@/apps/home';
import vmodal from 'vue-js-modal';
// import vuerx from 'vue-rx';

import { library } from '@fortawesome/fontawesome-svg-core';
import {
    FontAwesomeIcon,
    FontAwesomeLayers,
    FontAwesomeLayersText,
} from '@fortawesome/vue-fontawesome';

import { fas } from '@fortawesome/pro-solid-svg-icons';

import 'vue-good-table/dist/vue-good-table.css';
import Meta from 'vue-meta';

Vue.use(Meta);
Vue.use(vmodal, { dynamic: true, injectModalsContainer: true });
// Vue.use(vuerx);

Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('font-awesome-layers', FontAwesomeLayers);
Vue.component('font-awesome-layers-text', FontAwesomeLayersText);

library.add(fas);

// --- Sentry ----------------------------------------

// Sentry.init(
//     {
//         dsn: 'https://142584be5b7841dca6b5bcb92798787b@sentry.hespul.org/11',
//         integrations: [new Sentry.Integrations.Vue()],
//     }
// )

// --- /Sentry ----------------------------------------

function displayVueApp() {
    /* eslint-disable no-new */
    new Vue({
        el: '#app',
        // store,
        // router,
        components: { Home },
        template: '<Home/>',
    });
}

Vue.config.productionTip = false;

displayVueApp();
